// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PlaceOrderFooterFbCmp from "./PlaceOrderFooterFbCmp.bs.js";

function PickUpDropFallBackCmp(Props) {
  var formCmp = function (address_type) {
    return React.createElement("div", {
                className: "address"
              }, React.createElement("div", {
                    className: "progress-container"
                  }, React.createElement("div", {
                        className: "pin pin__" + (
                          address_type ? "red" : "green"
                        )
                      }), address_type ? null : React.createElement("div", {
                          className: "track_line"
                        })), React.createElement("div", {
                    className: "form"
                  }, React.createElement("p", {
                        className: "label"
                      }, address_type ? "TO" : "FROM"), React.createElement("div", undefined, React.createElement("div", {
                            className: "input loading-shimmer"
                          }), React.createElement("p", {
                            className: "label"
                          }, "House/Apartment"), React.createElement("div", {
                            className: "input loading-shimmer"
                          }), React.createElement("div", {
                            className: "flex-container"
                          }, React.createElement("div", {
                                className: "flex"
                              }, React.createElement("p", {
                                    className: "label"
                                  }, "Sender Name"), React.createElement("div", {
                                    className: "input loading-shimmer"
                                  })), React.createElement("div", {
                                className: "flex"
                              }, React.createElement("p", {
                                    className: "label"
                                  }, "Sender Phone"), React.createElement("div", {
                                    className: "input loading-shimmer"
                                  }))))));
  };
  return React.createElement("div", {
              className: "pickup_falbback_container"
            }, React.createElement("div", {
                  className: "map"
                }, React.createElement("div", {
                      className: "loading-shimmer"
                    })), formCmp(/* Pickup */0), formCmp(/* Drop */1), React.createElement(PlaceOrderFooterFbCmp.make, {}));
}

var make = PickUpDropFallBackCmp;

export {
  make ,
  
}
/* react Not a pure module */
